module.exports = [{
      plugin: require('../src/plugins/gatsby-plugin-adobe-launch/gatsby-browser.js'),
      options: {"plugins":[],"includeInDevelopment":true,"dataLayerName":"adobeDataLayer","routeChangeEventName":"flRouteChange"},
    },{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"SC Fund Library UAE","short_name":"SC FL AE","description":"Browse through a full list of funds using our interactive Fund Library and build an investment portfolio that matches your risk profile and investment objectives.","start_url":"/?source=pwa","scope":"https://www.sc.com/ae/investment/funds/","display":"standalone","icon":"src/icons/icons/icon-512x512.png","icon_options":{"purpose":"any"},"include_favicon":true,"theme_color":"#2772C7","background_color":"#F8F8F8","theme_color_in_head":true,"cache_busting_mode":"name","legacy":true,"crossOrigin":"use-credentials","cacheDigest":"1a0c647795739dd6c4af7b948f8ad276"},
    },{
      plugin: require('../node_modules/gatsby-plugin-offline/gatsby-browser.js'),
      options: {"plugins":[],"precachePages":["/","/fund-details","/funds-comparison"]},
    },{
      plugin: require('../node_modules/gatsby-plugin-next-seo/gatsby-browser.js'),
      options: {"plugins":[],"twitter":{"handle":"","site":"","cardType":"summary_large_image"},"noindex":false,"nofollow":false},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
